// javascript code used in the footer, etc.
document.addEventListener('DOMContentLoaded', () => {
  // footer
  const FEED_BACK_MESSAGE_MODAL = 'feedback-message';
  // sign up dom
  const $signUpEmail = document.querySelector('#sign-up-email');
  const $signUpSubmit = document.querySelector('#sign-up-submit');

  $signUpSubmit.addEventListener('click', (e) => {
    const email = $signUpEmail.value;
    const checkResult = xUtils.validateEmail(email);

    if (!checkResult.isValid) {
      publish(PUB_SUB_EVENTS.xModalOpen, {
        modalName: FEED_BACK_MESSAGE_MODAL,
        contentRender: ($slot) => {
          const $content = $slot.querySelector('.x-footer-modal__feedback-layer');
          const $cancel = $slot.querySelector('.x-footer-modal__operation-cancel');

          $content.innerHTML = `
            <h2 class="x-footer-modal__feedback-title">Submission Failed</h2>
            <div class="x-footer-modal__feedback-content">
              <p class="x-footer-modal__feedback-text">${checkResult.message}</p>
            </div>
          `;
          if (!$cancel.classList.contains('hidden')) {
            $cancel.classList.add('hidden');
          }
        },
      });
      return;
    }

    xUtils.showLoading();
    fetch('https://newsletter.xds.co/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email }),
      timeout: 30000,
    })
      .then((res) => res.json())
      .then((res) => {
        const titleDisplay =
          res.status === 'success' ? 'Submission Successful' : 'Submission Failed';
        const messageDisplay =
          res.status === 'success'
            ? 'Thank you for subscribing and for riding with us.'
            : res.error || 'Something went wrong, please try again later.';
        publish(PUB_SUB_EVENTS.xModalOpen, {
          modalName: FEED_BACK_MESSAGE_MODAL,
          contentRender: ($slot) => {
            const $content = $slot.querySelector('.x-footer-modal__feedback-layer');
            const $cancel = $slot.querySelector('.x-footer-modal__operation-cancel');

            $content.innerHTML = `
                <h2 class="x-footer-modal__feedback-title">${titleDisplay}</h2>
                <div class="x-footer-modal__feedback-content">
                  <p class="x-footer-modal__feedback-text">${messageDisplay}</p>
                </div>
              `;
            if (!$cancel.classList.contains('hidden')) {
              $cancel.classList.add('hidden');
            }
          },
        });
        $signUpEmail.value = '';
      })
      .catch((err) => {
        console.error(err);
        publish(PUB_SUB_EVENTS.xModalOpen, {
          modalName: FEED_BACK_MESSAGE_MODAL,
          contentRender: ($slot) => {
            const $content = $slot.querySelector('.x-footer-modal__feedback-layer');
            const $cancel = $slot.querySelector('.x-footer-modal__operation-cancel');

            $content.innerHTML = `
              <h2 class="x-footer-modal__feedback-title">Submission Failed</h2>
              <div class="x-footer-modal__feedback-content">
                <p class="x-footer-modal__feedback-text">Something went wrong, please try again later.</p>
              </div>
            `;
            if (!$cancel.classList.contains('hidden')) {
              $cancel.classList.add('hidden');
            }
          },
        });
      })
      .finally(() => {
        xUtils.hideLoading();
      });
  });
  subscribe(PUB_SUB_EVENTS.xModalConfirm, (params) => {
    if (params.modalName === FEED_BACK_MESSAGE_MODAL) {
      params.closeMethod && params.closeMethod();
    }
  });
});
